import * as Sentry from '@sentry/browser'
import { SENTRY_ENV } from '..'
import { appSentryBrowserOptions } from './browserOptions'

// This file is used to ensure the correct Sentry instance is used when the header and other
// apps co-exist.

export const setAppSentry = (): void => {
  // Sentry doesn't always initialise for some reason.
  Sentry.init({ debug: SENTRY_ENV !== 'production' })

  const sentryClient = new Sentry.BrowserClient(appSentryBrowserOptions)
  Sentry.makeMain(new Sentry.Hub(sentryClient))
}
